"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = exports.without = exports.take = exports.forEach = exports.mapValues = void 0;
function mapValues(object, mapFn) {
    if (Array.isArray(object)) {
        throw "This map is just for objects, just use array.map for arrays";
    }
    return Object.keys(object).reduce(function (result, key) {
        result[key] = mapFn(object[key], key);
        return result;
    }, {});
}
exports.mapValues = mapValues;
function forEach(object, mapFn) {
    if (Array.isArray(object)) {
        throw "This map is just for objects, just use array.forEach for arrays";
    }
    return Object.keys(object).forEach(function (key) {
        mapFn(object[key], key);
    });
}
exports.forEach = forEach;
function take(arr, count) {
    if (count === void 0) { count = 0; }
    return arr.slice(0, count);
}
exports.take = take;
function without(arr, values) {
    return arr.filter(function (val) { return values.indexOf(val) === -1; });
}
exports.without = without;
function pick(object, pick) {
    var res = {};
    pick.forEach(function (key) {
        if (object[key] !== undefined) {
            res[key] = object[key];
        }
    });
    return res;
}
exports.pick = pick;
//# sourceMappingURL=collections.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@giphy/js-util/dist/collections.js
// module id = 489
// module chunks = 2